import { connect } from 'react-redux';

import services from 'services';
import { openWindow } from 'store/actions/windows';
import Warning from '../../events/Warning';
import Error from '../../events/Error';
import { RackCall } from './RackCall';
import { RackCallActions } from './RackCall.cp';
import { isOffline, isKnownStatus } from '../../widgets-dock/equipment-status';
import {
  Content,
  CheckingBorder,
  RackWrapper,
  Barriers,
  Barrier,
  IconTitle,
  Id,
  OfflineDot,
  Tip,
  TipTitle,
  TipRow,
  Dot,
  TipMsg,
  TipOk,
  TipOffline,
  TipHint,
} from './Rack.styled';

const rackIcons = {
  single_rack: 'single_rack.svg',
  double_rack: 'double_rack.svg',
  payment_terminal: 'payment_terminal.svg',
  cashbox: 'cashbox-icon.svg',
  server: 'data-server.svg',
  goose: 'goose.svg',
};

const Rack = (props) => {
  /**
   * get icon for rack type
   * @returns
   */
  const getIcon = () => {
    const icon = rackIcons[props.type];
    if (!icon) {
      throw new Error('Не найдена иконка соотвествующая типу стойки');
    }
    return <img src={`/images/${icon}`} alt="" />;
  };

  /**
   * get barriers
   * @returns
   */
  const getBarriers = () => {
    switch (props.barriersCount) {
      case 2:
        return (
          <Barriers>
            <Barrier />
            <Barrier />
          </Barriers>
        );
      case 1:
        return (
          <Barriers>
            <Barrier />
          </Barriers>
        );
      case 0:
      default:
        return null;
    }
  };

  const showWindow = () => {
    props.openWindow({
      id: props.id,
      type: 'rack',
      data: { id: props.id, type: props.type, barriersCount: props.barriersCount, withSignals: !!props.events.length },
      header: services.getNodeTitle(props.type, props.id, props.caption),
    });
  };

  const showEvent = () => {
    const events = [...props.events];
    events.sort((first, second) => {
      if (first.type === 'critical' && second.type === 'notification') {
        return -1;
      }
      if (first.type === 'notification' && second.type === 'critical') {
        return 1;
      }
      if ((first.type === 'critical' && second.type === 'info') || (first.type === 'notification' && second.type === 'info')) {
        return -1;
      }
      if ((first.type === 'info' && second.type === 'critical') || (first.type === 'info' && second.type === 'notification')) {
        return 1;
      }

      return 0;
    });

    const event = events[0];
    let Component = null;
    switch (event.type) {
      case 'critical':
        Component = Error;
        break;
      case 'notification':
        Component = Warning;
        break;
      default:
        return null;
    }
    return <Component key={'ev_' + event.id} data={event} showWindow={showWindow} />;
  };

  const getViewRackId = () => {
    //console.log(props)
    if (props.caption) {
      return props.caption;
    }
    return props.type === 'cashbox' ? '' : window.service.call('getEquipmentInnerId', props.id);
  };

  const cl = props.type;

  // связь с устройством: приглушаем плитку и меняем подсказку, если оно недоступно
  const offline = isOffline(props.equipment);

  // state class for the card glow: offline (muted) > call (blue) > critical (red) > notification (amber) > idle (none)
  const hasCritical = props.events.some((e) => e.type === 'critical');
  const hasNotification = !hasCritical && props.events.some((e) => e.type === 'notification');
  // пока в сторе нет данных об устройстве — «Проверка»
  const checking = !isKnownStatus(props.equipment);
  const cl0 = checking
    ? 'checking'
    : offline
      ? 'offline'
      : props.call
        ? 'with-call'
        : hasCritical
          ? 'state-critical'
          : hasNotification
            ? 'state-notification'
            : '';

  const idText = getViewRackId();

  const nodeTitle = services.getNodeTitle(props.type, props.id, props.caption);
  const sev = { critical: 0, notification: 1, info: 2 };
  const tipEvents = [...props.events].sort((a, b) => (sev[a.type] ?? 3) - (sev[b.type] ?? 3));

  return (
    <RackWrapper>
      <Content onClick={() => showWindow()} className={cl0}>
        {props.barriersPosition === 'top' && getBarriers()}
        <IconTitle className={cl}>{getIcon()}</IconTitle>
        {props.barriersPosition === 'bottom' && getBarriers()}
        {idText !== '' && idText != null && <Id className={offline ? cl + ' offline' : cl}>{idText}</Id>}
        {offline && <OfflineDot title="Нет связи" />}
        {checking && (
          <CheckingBorder>
            <rect x="0.75" y="0.75" width="calc(100% - 1.5px)" height="calc(100% - 1.5px)" rx="6" ry="6" />
          </CheckingBorder>
        )}
      </Content>
      {props.events.length > 0 && showEvent()}
      {props.call && <RackCall info={props.call} />}
      <Tip $call={props.call?.status === 'wait'}>
        {props.call && <RackCallActions info={props.call} />}
        <TipTitle>{nodeTitle}</TipTitle>
        {checking ? (
          <>
            <TipHint>Проверка связи…</TipHint>
          </>
        ) : offline ? (
          <>
            <TipOffline>Нет связи</TipOffline>
            {tipEvents.slice(0, 3).map((ev, i) => (
              <TipRow key={ev.id || i}>
                <Dot className={ev.type} />
                <TipMsg>{ev.message || ev.description || ev.method}</TipMsg>
              </TipRow>
            ))}
            <TipHint>Нажмите для управления</TipHint>
          </>
        ) : tipEvents.length > 0 ? (
          <>
            {tipEvents.slice(0, 3).map((ev, i) => (
              <TipRow key={ev.id || i}>
                <Dot className={ev.type} />
                <TipMsg>{ev.message || ev.description || ev.method}</TipMsg>
              </TipRow>
            ))}
            <TipHint>{tipEvents.length > 3 ? `+${tipEvents.length - 3} ещё · нажмите для управления` : 'Нажмите для управления'}</TipHint>
          </>
        ) : (
          <>
            <TipOk>В работе</TipOk>
            <TipHint>Нажмите для управления</TipHint>
          </>
        )}
      </Tip>
    </RackWrapper>
  );
};

const mapStateToProps = (store, props) => {
  const events = [];
  const rackEvents = store.events.events[props.id];
  for (let key in rackEvents) {
    let event = rackEvents[key];
    events.push(event);
  }

  const testCall = false;
  // console.log("store.calls.calls[props.id]", store.calls.calls[props.id]);
  const call = testCall
    ? {
        status: 'wait',
        id: '1763459905.809795',
        source: '111',
        source_inner_id: 'goose-1',
      }
    : store.calls.calls !== undefined
      ? store.calls.calls[props.id]
      : null;

  return {
    events,
    equipment: store.equipment[props.id],
    call,
  };
};

export default connect(mapStateToProps, {
  openWindow,
})(Rack);
